<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left add-details">
    <div class="wrapper-login-page">
      <div class="login-page">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1>{{'NEW_TEXT.create_company_account' | translate}}</h1>
          <h6>{{'CREATE_ACCOUNT.signup_for_a_new_company_account_by_adding_your_information_below' | translate}}</h6>
        </div>
        <form [formGroup]="createCompanyAccountForm" (ngSubmit)="onSubmitCreateCompanyAccountForm()" class="wrapper-content-auth">
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['full_name'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.full_name' | translate}}</span>
            <div class="custom-input">
              <input type="text" formControlName="full_name" placeholder="{{'NEW_TEXT.enter_your_full_name' | translate}}">
            </div>
            <div *ngIf="createCompanyAccountForm.controls['full_name'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['full_name'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input">
            <span class="label-input">{{'NEW_TEXT.company_name' | translate}}</span>
            <div class="custom-input">
              <input type="text" formControlName="company_name" placeholder="{{'NEW_TEXT.enter_company_name' | translate}}">
            </div>
            <div *ngIf="createCompanyAccountForm.controls['company_name'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['company_name'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['company_website'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.company_website' | translate}}</span>
            <div class="custom-input">
              <input type="text" formControlName="company_website" placeholder="{{'NEW_TEXT.enter_company_website' | translate}}">
            </div>
            <div *ngIf="createCompanyAccountForm.controls['company_website'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['company_website'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['email'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.email_address' | translate}}</span>
            <div class="custom-input wrapper-email-address-autocomplete">
              <input type="text" formControlName="emailForView" placeholder="{{'NEW_TEXT.email_address' | translate}}">
              <div class="email-autocomplete">
                <span>{{companyMailSuffix}}</span>
              </div>
            </div>
            <div *ngIf="createCompanyAccountForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['email'] | formControlErrorMessages: 'Please enter a valid email address.': formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.phone_number' | translate}}</span>
            <div class="wrapper-phone-number open" [ngClass]="{'open': isAreaCodeOpen}">
              <div #areaCodeBtn class="wrapper-flags" (click)="isAreaCodeOpen = !isAreaCodeOpen">
                <img class="icon-flag" [src]="'../../../../assets/icons/flags/' + selectedArea.code.toLowerCase() + '.png'" alt="">
                <img class="icon-arrow-flags" src="../../../assets/icons/icon-arrow-left.svg" alt="">
              </div>
              <div class="wrapper-number-country">
                <span>{{selectedArea.phone_code}}</span>
              </div>
              <input type="text" formControlName="phone_number">
              <div class="content-dropdown-phone-number" *ngIf="isAreaCodeOpen">
                <div class="item-dropdown-phone-number" *ngFor="let country of Countries" (click)="onSelectCodeArea(country)">
                  <img [src]="'../../../../assets/icons/flags/' + country.code.toLowerCase() + '.png'" alt="">
                  <span>{{country.name}} ({{country.phone_code}})</span>
                </div>
              </div>
            </div>
            <div *ngIf="createCompanyAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.' : formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['phone_number'] | formControlErrorMessages: 'Enter valid phone number.': formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['username'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.username' | translate}}</span>
            <div class="custom-input">
              <input type="text" (input)="onSearch()" formControlName="username" placeholder="{{'NEW_TEXT.enter_your_username' | translate}}">
            </div>
            <div *ngIf="createCompanyAccountForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['username'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
            <div *ngIf="taken"
                 class="wrapper-error-message-icon">
              <img src="../../../../assets/icons/icon-error.svg" alt="">
              <span>{{'CREATE_ACCOUNT.this_username_is_already_taken' | translate}}</span>
            </div>

            <div *ngIf="taken && available.length" class="wrapper-error-message-available">
              <span>{{'CREATE_ACCOUNT.here_are_a_few_available_alternatives_you_can_use' | translate}}:</span>
              <span *ngFor="let name of available">&#64;{{ name }}</span>
            </div>

            <div class="wrapper-notice">
              <img src="../../../../assets/images/onboarding/info.svg" alt="">
              <p>{{'CREATE_ACCOUNT.this_will_be_your_unique_identity' | translate}}</p>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['password'] | formControlErrorMessages: null : formTriedToSubmit}">
            <span class="label-input">{{'NEW_TEXT.password' | translate}}</span>
            <div class="custom-input">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                placeholder="{{'NEW_TEXT.enter_password' | translate}}"
                formControlName="password">
              <img *ngIf="!isPasswordVisible" (click)="isPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
              <img *ngIf="isPasswordVisible" (click)="isPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
            </div>
            <div *ngIf="createCompanyAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-input" [ngClass]="{'error': createCompanyAccountForm.controls['confirmPassword'] | formControlErrorMessagesOnSubmit: 'Passwords do not match' : formTriedToSubmit}">
            <div class="custom-input">
              <input
                [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                placeholder="{{'NEW_TEXT.enter_password' | translate}}"
                formControlName="confirmPassword">
              <img *ngIf="!isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
              <img *ngIf="isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
            </div>
            <div *ngIf="(createCompanyAccountForm.controls['confirmPassword'].errors && (formTriedToSubmit || createCompanyAccountForm.controls['confirmPassword'].touched))" class="wrapper-error-message">
              <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
              <span>{{createCompanyAccountForm.controls['confirmPassword'] | formControlErrorMessagesOnSubmit: null: formTriedToSubmit}}</span>
            </div>
          </div>
          <div class="wrapper-custom-checkbox">
            <input formControlName="tos" type="checkbox" id="custom-checkbox">
            <label for="custom-checkbox">
              <span class="custom-checkbox-wrapper-check"></span>
              {{'NEW_TEXT.i_agree_to_the' | translate}} <span>{{'NEW_TEXT.terms_of_service' | translate}} </span>{{'NEW_TEXT.and' | translate}} <span>{{'NEW_TEXT.privacy_policy' | translate}}.</span>
            </label>
          </div>
          <button type="submit" [disabled]="createCompanyAccountForm.invalid" class="custom-btn custom-btn--primary">
            <span>{{'NEW_TEXT.create_company_account' | translate}}</span>
            <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
          </button>
        </form>
      </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>
